import { gql } from "@apollo/client";

export const UPDATE_TEMPLATE_EXTRACTION_FIELDS = gql`
  mutation updateTemplateExtractionFields(
    $templateId: String
    $clientIdentifier: String
    $input: [TemplateFieldInput!]!
  ) {
    invoiceInterpretation {
      updateTemplateExtractionFields(
        templateId: $templateId
        clientIdentifier: $clientIdentifier
        input: $input
      ) {
        success
      }
    }
  }
`;
